import { render } from "./Apelido.vue?vue&type=template&id=b7950d22"
import script from "./Apelido.vue?vue&type=script&lang=js"
export * from "./Apelido.vue?vue&type=script&lang=js"
script.render = render

export default script